import React, { useState } from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Tabs } from "antd";

import globalColors from "../styles/globalColors";

type TabItem = {
  color?: string;
  key: string;
  label: string;
  count?: string;
};

type Props = {
  children: any;
  onChangeTab: (key: string) => void;
  selectedTab: string;
  tabs: TabItem[];
};

const TabContainer: React.FC<Props> = ({
  children,
  onChangeTab,
  selectedTab,
  tabs
}) => {
  return (
    <div css={styles.container}>
      <Tabs
        animated={false}
        defaultActiveKey={selectedTab}
        activeKey={selectedTab}
        onChange={(key: string) => onChangeTab(key)}
        renderTabBar={(props: any) => (
          <div css={styles.tabsContainer}>
            {tabs.map((tab, index) => {
              const last = index === tabs.length - 1;
              const selected = tab.key === selectedTab;

              return (
                <div
                  onClick={() => onChangeTab(tab.key)}
                  key={tab.key}
                  css={[
                    styles.tab,
                    selected && styles.tabSelected,
                    last && styles.tabLast,
                    { borderTopColor: tab.color || globalColors.gray }
                  ]}
                >
                  <div css={styles.tabLabel}>{tab.label.toUpperCase()}</div>
                  {tab.count !== undefined && (
                    <div css={styles.tabCount}>{tab.count}</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      >
        {children}
      </Tabs>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: globalColors.white,
    margin: "10px 0",
    paddingBottom: 2,
    border: `1px solid ${globalColors.lightGray}`,
    borderTopWidth: 0,
    ".ant-tabs-content": {
      padding: 10,
      paddingTop: 30,
      paddingBottom: 30
    }
  },
  contentContainer: {
    backgroundColor: globalColors.white,
    margin: "0 2px 2px",
    padding: 10
  },
  tab: {
    cursor: "pointer",
    backgroundColor: globalColors.lightGray,
    borderTop: `14px solid ${globalColors.gray}`,
    display: "flex",
    flex: 1,
    fontSize: 14,
    fontWeight: 600,
    marginRight: 4,
    padding: "15px 10px 15px 10px",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  tabLabel: {},
  tabCount: {
    color: globalColors.textBlue
  },
  tabLast: {
    marginRight: 0
  },
  tabSelected: {
    backgroundColor: globalColors.white
  },
  tabsContainer: {
    display: "flex",
    backgroundColor: globalColors.lightestGray
  }
};

export default TabContainer;
